/**
 * DCMS FRONTEND API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const SessionTypeEnum = {
    IndividualSession: 'INDIVIDUAL_SESSION',
    InitialConsultation: 'INITIAL_CONSULTATION'
} as const;
export type SessionTypeEnum = typeof SessionTypeEnum[keyof typeof SessionTypeEnum];

